import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students')({
    component: Outlet,
    beforeLoad: requireRouteAudience(['staff', 'parent', 'student']),
    staticData: {
        crumb: { label: 'Students' },
    }
})
